import { graphql, useStaticQuery } from 'gatsby'
import * as React from 'react'
import { Fragment } from 'react'

type Props = Readonly<{
  path: string
  locale: string
  metadata: Nullable<{
    auteur: string
    copyright: string
    titre: string
    description: string
    labels: {
      label: string
      data: string
    }[]
  }>
}>

const SEO: React.FC<Props> = (props) => {
  const data = useStaticQuery(graphql`
    query {
      site {
        siteMetadata {
          title
          siteUrl
        }
      }
      images: allImageSharp {
        edges {
          node {
            original {
              src
            }
          }
        }
      }
    }
  `)
  const auteur = props.metadata ? props.metadata.auteur : ''
  const copyright = props.metadata ? props.metadata.copyright : ''
  const titre = props.metadata && props.metadata.titre !== '' ? `${ props.metadata.titre } | ` : ''
  const titreComplet = `${ titre }${ data.site.siteMetadata.title } | ${ props.locale.toUpperCase() }`
  const description = props.metadata ? props.metadata.description : ''

  const images = data.images.edges.map(({ node }) => node.original)
  const logo = images.find(i => i.src.includes('logo_1000x500'))

  return (
      <>
        <title>{ titreComplet }</title>
        <meta name="viewport" content="width=device-width, initial-scale=1"/>

        { props.metadata && <meta name="author" content={ auteur }/> }
        { props.metadata && <meta name="copyright" content={ copyright }/> }
        { props.metadata && <meta name="description" content={ description }/> }

        { props.metadata && <meta property="og:site_name" content={ data.site.siteMetadata.title }/> }
        { props.metadata && <meta property="og:title" content={ titre }/> }
        { props.metadata && <meta property="og:type" content="article"/> }
        { props.metadata && <meta property="og:description" content={ description }/> }
        { props.metadata && <meta property="og:url" content={ `${ data.site.siteMetadata.siteUrl }${ props.path }` }/> }
        { props.metadata && logo && <meta property="og:image" content={ logo.src }/> }

        { props.metadata && <meta property="twitter:card" content="summary_large_image"/> }
        { props.metadata && <meta property="twitter:title" content={ titre }/> }
        { props.metadata && <meta property="twitter:description" content={ description }/> }
        { props.metadata && logo && <meta property="twitter:image" content={ logo.src }/> }
        { props.metadata && props.metadata.labels.map((l, index) => (
            <Fragment key={ index }>
              <meta property={ `twitter:label${ index + 1 }` } content={ l.label }/>
              <meta property={ `twitter:data${ index + 1 }` } content={ l.data }/>
            </Fragment>
        )) }
      </>
  )
}

export default SEO
